<template>
  <div
    v-bind:class="['bto-sb-base-col', `bto-sb-col-${colcount}`, coldata.settings.customClass]"
    :ref="`bto-sb-col-${colcount}`"
    v-bind:id="`bto-sb-col-${coldata.id}`">
    <component
      :is="useSticky ? 'div' : 'empty-component'"
      ref="stickyCol"
      :class="{
        'bto-sb-col-sticky': true,
        'bto-sb-col-fixed': sticky && fixed,
        'bto-sb-col-abs': sticky && !fixed,
      }"
      :style="getTopStyle">
      <!--        <div class="scroll-container"-->
      <!--             v-bar-->
      <!--             :ref="`scrc${colcount}`">-->
      <!--            <div>-->
      <!--                <slot></slot>-->
      <!--            </div>-->
      <!--        </div>-->
      <slot></slot>
    </component>
  </div>
</template>

<script>
  import EmptyComponent from '@bto-widgets/utils/src/shared/empty-component';

  export default {
    name: 'ColComponent',
    components: {
      EmptyComponent,
    },
    props: {
      colcount: {
        type: Number,
        required: true,
        default: 1,
      },
      coldata: {
        type: Object,
        required: true,
        default: () => {
        },
      },
      useSticky: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        scrolling: false,
        fixed: false,
        sticky: false,
        resizeObserver: null,
        vertialObserver: null,
        topPosition: 0,
      };
    },
    computed: {
      getTopStyle() {
        if (this.topPosition === 0 || !this.fixed) {
          return null;
        }
        return {
          top: `${this.topPosition}px`,
          'max-height': `calc(100vh - ${this.topPosition}px)`
        };
      },
    },
    watch: {
      useSticky(val) {
        if (val) {
          this.initSticky();
          return;
        }
        this.removeSticky();
      },
    },
    mounted() {
      if (this.useSticky) {
        this.initSticky();
        if (APP_SETTINGS.settings.elementTop) {
          const el = document.querySelector(APP_SETTINGS.settings.elementTop);
          if (!el) return;
          const rects = el.getBoundingClientRect();
          this.topPosition = rects.height + rects.top + 5;
        }
      }
    },
    destroyed() {
      this.removeSticky();
    },
    methods: {
      initSticky() {
        window.addEventListener('scroll', this.handleScroll);
        this.resizeObserver = new ResizeObserver((entries) => {
          for (const entry of entries) {
            const stickyEl = this.$refs['stickyCol'];
            if (!stickyEl) return;
            stickyEl.style.width = `${entry.borderBoxSize[0].inlineSize}px`;
          }
        });

        this.resizeObserver.observe(this.$refs[`bto-sb-col-${this.colcount}`]);
        this.initVerticalObserver();
      },
      removeSticky() {
        this.sticky = false;
        this.fixed = false;
        window.removeEventListener('scroll', this.handleScroll);
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
        }
        if (this.vertialObserver) {
          this.vertialObserver.disconnect();
        }
      },
      initVerticalObserver() {
        const stickyEl = this.$refs['stickyCol'];
        if (!stickyEl) return;
        this.vertialObserver = new ResizeObserver(() => {
          this.handleScroll();
        });
        this.vertialObserver.observe(stickyEl);
      },
      handleScroll() {
        if (!this.scrolling) {
          window.requestAnimationFrame(() => {
            let sbMain = document.querySelector('[data-bto-app]');
            if (!sbMain) return;
            const rect = sbMain.getBoundingClientRect();
            if (rect.y <= 0) {
              this.sticky = true;
              const stickyEl = this.$refs['stickyCol'];
              const emptySpace = window.innerHeight - stickyEl.offsetHeight - this.topPosition;
              const extraSpace = emptySpace <= 5 ? 0 : emptySpace;
              this.fixed = rect.bottom + extraSpace > window.innerHeight;
            } else {
              this.sticky = false;
              this.fixed = false;
            }

            this.scrolling = false;
          });
        }

        this.scrolling = true;
      },
    }
  };
</script>
<style scoped>
  .bto-sb-col-sticky {
    max-height: 100vh;
    overflow-y: auto;
  }
  .bto-sb-col-sticky {
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .bto-sb-short-col .bto-sb-col-sticky {
    overflow-y: unset;
  }
  .bto-sb-col-sticky::-webkit-scrollbar {
    display: none;
  }
  .bto-sb-col-sticky.bto-sb-col-3 {
    right: 5px;
  }
  .bto-sb-col-sticky.bto-sb-col-fixed {
    position: fixed;
    top: 5px;
  }
  .bto-sb-col-sticky.bto-sb-col-abs {
    position: absolute;
    bottom: 5px;
  }
</style>
<style>
  div.bto-sb-base-col {
    /*height: 100%;*/
  }

  div.scroll-container {
    /*height: 100%;*/
    position: relative;
  }

  /** Chrome and safari **/
  .bto-sb-container .vb-content {
    width: 100% !important;
  }

  /*::-webkit-scrollbar {*/
  /*    width: 0;*/
  /*    opacity: 0;*/
  /*}*/

  /** Firefox **/
  @-moz-document url-prefix() {
    .bto-sb-container .vb-content {
      scrollbar-width: thin;
      width: calc(100% + 8px) !important;
    }
  }

  /** IE **/
  @supports (-ms-ime-align: auto) {
    .bto-sb-container .vb-content {
      scrollbar-width: thin;
      width: calc(100% + 14px) !important;
    }
  }
</style>
